<script setup lang="ts">
  import type { HeroMessage } from '@/models/hero';
  import { computed } from 'vue';
  import type { PropType } from 'vue';

  const props = defineProps({
    message: {
      type: Object as PropType<HeroMessage>,
      required: true
    }
  });

  const finalClasses = computed(() => props.message.classes?.map((c) => `hero-card--${c}`) ?? []);
</script>

<template>
  <div
    :id="message.id"
    :class="['hero-card', ...finalClasses]">
    <div class="hero-card__left">
      <div
        v-if="message.image"
        class="hero-card__image">
        <img
          :src="message.image"
          alt="image" />
      </div>
    </div>
    <div class="hero-card__right">
      <div
        v-if="message.title"
        class="hero-card__content"
        v-html="message.title" />
    </div>
  </div>
</template>
